/**
*
* FieldConditionalLogicEditor
*
*/
import React from 'react';
import PropTypes from 'prop-types';

import { iconBranching } from 'utils/svgConstants';
import CheckBoxAttribute from '../../CheckBoxAttribute';
import BranchingEditor from './BranchingEditor';
import ConfirmationModal from '../../../ConfirmationModal';

const deleteText = `This action will delete all branching assignments for all questions.
\rDo you want to proceed?`;

class ConditionalityLogicEditor extends React.Component {
  state = {
    showModal: false,
  }

  onCancel = () => {
    this.setState({ showModal: false });
  }

  onConfirm = () => {
    this.setState({ showModal: false }, () => this.props.toggleBranching(this.props.values.id));
  }

  setFieldConditionalityInfo = (_, val) => {
    if (!val) {
      this.setState({ showModal: true });
    } else {
      this.props.toggleBranching(this.props.values.id);
    }
  };

  render() {
    const { activeBranches, fieldConditionalityInfo, keyPath, isBranchingField, values } = this.props;
    return (
      <div>
        <div className="row px-5 pb-3">
          <div className="col mt-2">
            <div className="row">
              <div className="d-inline-flex">
                <CheckBoxAttribute
                  className="mt-1"
                  keyPath={[...keyPath, 'branchingCheckbox']}
                  value={isBranchingField}
                  disabled={Boolean(Object.keys(fieldConditionalityInfo.branchingFields).length && !isBranchingField)}
                  onCheckBoxChange={this.setFieldConditionalityInfo}
                  labelClassName="font-weight-bold"
                >Make this a branching question
                </CheckBoxAttribute>
                <span className="ml-8">
                  <svg className="fill-branching-gray" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
                    <g transform="rotate(180, 256, 256)">
                      <path d={iconBranching} />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            {isBranchingField ? (
              <BranchingEditor
                activeBranches={activeBranches}
                id={values.id}
                name={values.name}
              />
            ) : null}
          </div>
        </div>
        <ConfirmationModal
          title="Remove Branching"
          onCancel={this.onCancel}
          visible={this.state.showModal}
          confirmText="Remove Branching"
          cancelText="Cancel"
          onConfirm={this.onConfirm}
          content={deleteText}
        />
      </div>
    );
  }
}

ConditionalityLogicEditor.propTypes = {
  activeBranches: PropTypes.object.isRequired,
  isBranchingField: PropTypes.bool.isRequired,
  toggleBranching: PropTypes.func.isRequired,
  fieldConditionalityInfo: PropTypes.object.isRequired,
  keyPath: PropTypes.array.isRequired,
  values: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ConditionalityLogicEditor;
